export function isLinkSameDomain(link: string) {
  try {
    const url = new URL("", link);
    return url.hostname === window.location.hostname;
  } catch (error) {
    return false; // this is to catch situations where the link passed is not a valid url
  }
}
